import {style} from "@vanilla-extract/css";

export const iframe = style({
    aspectRatio: "1/1.41",
    width: "100%",
    maxHeight: "1200px"
});
